import { Module, AllEnterpriseModule } from 'ag-grid-enterprise';

export const agGridModules: Module[] = [AllEnterpriseModule];
